import { gql } from "@apollo/client";
import { DeletionResponseDeepNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const DELETE_PRODUCT_IMAGE = gql`
  ${DeletionResponseDeepNestingFragment}
  mutation DeleteProductImage($imageId: ID!) {
    deleteProductImage(imageId: $imageId) {
      ...DeletionResponseDeepNesting
    }
  }
`;
